import { List } from './list';
import { Single } from './single';
import { Repository } from './repository';

export default {
  List,
  Single,
  Repository,
};
